import { render } from "./HomePage.vue?vue&type=template&id=72936a48"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fr201\\Google Drive\\Sites internet\\Lavigna\\lavigna\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__